import { participantConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { commonService } from "../_services";
import { alertActions } from ".";

export const participantActions = {
  getParticipantById,
  saveParticipant,
  getParticipantsList,
  deleteParticipant
};

function getParticipantById(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(participantConstants.PARTICIPANT_BY_ID_REQUEST, catObj));
    commonService.withToken(apiName, catObj).then(
      participantData => {
        dispatch(commonAction.success(participantConstants.PARTICIPANT_BY_ID_SUCCESS, participantData));
      },
      error => {
        dispatch(commonAction.failure(participantConstants.PARTICIPANT_BY_ID_FAILURE, error));
      }
    );
  };
}

//-- school save
function saveParticipant(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(participantConstants.PARTICIPANT_ADDED_REQUEST, catObj));
    commonService.withToken(apiName, catObj).then(
      participantData => {
        dispatch(alertActions.success("Participant Added Successfully"));
        setTimeout(function () {
          dispatch(alertActions.clear());
        }, 3000);
        dispatch(commonAction.success(participantConstants.PARTICIPANT_ADDED_SUCCESS, participantData));
      },
      error => {
        dispatch(commonAction.failure(participantConstants.PARTICIPANT_ADDED_FAILURE, error));
        // dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}

//-- getParticipantsList
function getParticipantsList(apiName, participantData) {

  return dispatch => {
    dispatch(
      commonAction.request(participantConstants.PARTICIPANT_LIST_REQUEST, participantData)
    );
    commonService.withToken(apiName, participantData).then(
      notification => {
        dispatch(
          commonAction.success(participantConstants.PARTICIPANT_LIST_SUCCESS, notification)
        );
      },
      error => {
        dispatch(
          commonAction.failure(participantConstants.PARTICIPANT_LIST_ERROR, error)
        );
        dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}


//delete school
function deleteParticipant(apiName, getApi, catObj) {
  return dispatch => {
    dispatch(commonAction.request(participantConstants.DELETE_PARTICIPANT_REQUEST, catObj));
    commonService.withToken(apiName, catObj).then(
      participantData => {
        dispatch(alertActions.success("Participant deleted Successfully"));
        setTimeout(function () {
          dispatch(alertActions.clear());
        }, 3000);
        dispatch(getParticipantsList(getApi, catObj));
        //dispatch(commonAction.success(participantConstants.DELETE_PARTICIPANT_SUCCESS, participantData));
      },
      error => {
        dispatch(commonAction.failure(participantConstants.DELETE_PARTICIPANT_FAILURE, error));
      }
    );
  };
}